import { useEffect, useState } from "react"
import { fetchServerInfo, type ServerInfo } from "@/lib/server-info"

export function useServerInfo(): { info: ServerInfo | null; loading: boolean } {
  const [info, setInfo] = useState<ServerInfo | null>(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    let cancelled = false
    fetchServerInfo().then((result) => {
      if (cancelled) return
      setInfo(result)
      setLoading(false)
    })
    return () => {
      cancelled = true
    }
  }, [])

  return { info, loading }
}
